import { ReactElement } from 'react';
import {
    DragDropContext,
    Draggable as DND_Draggable,
    Droppable,
    DropResult,
} from '@hello-pangea/dnd';

import type { ImageIconTypeUnion } from '../types/enums/imageicontype.enum';
import { MediaType } from '../types/enums/mediatype.enum';

import { Media } from '../types/mediaTypes';

export type DraggableItemType = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    media: Media | any;
    overlayText?: string;
    buttonType: ImageIconTypeUnion;
    onClick: (mediaId: number) => void;
};
type DraggableProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    items: DraggableItemType[] | any;
    renderer: (item: DraggableItemType) => ReactElement;
    onDragEnd: (result: {
        source: { index: number; droppableId: MediaType };
        destination: { index: number };
    }) => void;
    object?: string;
};

function Draggable(props: DraggableProps) {
    const { items, object, renderer, onDragEnd } = props;
    const draggableItems = items.map((item: DraggableItemType) => {
        // CRUTCH for cases when media is a new file that was just uploaded
        if (object) {
            return {
                ...item,
                [object]: item[object as keyof typeof item],
            };
        } else {
            return item;
        }
    });
    const itemType = MediaType.SCREENSHOT;

    const handleDragEnd = (result: DropResult) => {
        onDragEnd({
            source: {
                index: result.source.index,
                droppableId: itemType,
            },
            destination: { index: result.destination?.index || 0 },
        });
    };

    return (
        <>
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable
                    droppableId="droppable-draggable"
                    direction="horizontal"
                >
                    {(provided) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                                gap: 8,
                            }}
                        >
                            {draggableItems.map(
                                (item: DraggableItemType, index: number) => {
                                    // CRUTCH for cases when media is a new file that was just uploaded
                                    const displayItem = object
                                        ? item[object as keyof typeof item]
                                        : item;
                                    return (
                                        <DND_Draggable
                                            key={`draggable_item_${index}`}
                                            draggableId={`draggable_${index}`}
                                            index={index}
                                        >
                                            {(dragProvided) => (
                                                <div
                                                    ref={dragProvided.innerRef}
                                                    {...dragProvided.draggableProps}
                                                    {...dragProvided.dragHandleProps}
                                                    style={{
                                                        ...(dragProvided
                                                            .draggableProps
                                                            .style ?? {}),
                                                    }}
                                                >
                                                    {renderer(
                                                        displayItem as DraggableItemType,
                                                    )}
                                                </div>
                                            )}
                                        </DND_Draggable>
                                    );
                                },
                            )}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </>
    );
}

export default Draggable;
